/* unplugin-vue-components disabled */import { render } from "./sdopenUniversity.vue?vue&type=template&id=e28dc88e&scoped=true"
import script from "./sdopenUniversity.vue?vue&type=script&lang=js"
export * from "./sdopenUniversity.vue?vue&type=script&lang=js"

import "./sdopenUniversity.vue?vue&type=style&index=0&id=e28dc88e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28dc88e"]])

export default __exports__